import { RoleCard } from '@components/RoleCard';
import { Nullable } from '@utils/util.types';
import { useTranslation } from 'react-i18next';

type RoleOption = {
	role: string;
	titleKey: string;
	isDisabled?: boolean;
};

export const RoleSelector = ({
	selectedRole,
	onSelect,
	roles,
}: {
	selectedRole: Nullable<string>;
	onSelect: (role: string) => void;
	roles: RoleOption[];
}) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col sm:flex-row gap-[20px] items-center justify-center">
			{roles.map(({ role, isDisabled, titleKey }) => (
				<RoleCard
					key={role}
					className="w-full"
					role={role}
					isDisabled={isDisabled}
					title={t(titleKey)}
					selectedRole={selectedRole}
					onSelect={() => onSelect(role)}
				/>
			))}
		</div>
	);
};
